import { useMutation } from '@apollo/client';
import GET_FACET from '../../../aem-core-components/queries/mutation_get_facet.graphql';
import { getFacetsAPI } from '../../../aem-core-components/actions/product/actions';
import { logError } from '../../global/utils/logger';

const DEFAULT_NUMERIC_FACET_LIMIT = 4;
export const FACET_TYPES = {
    NUMERIC_RANGE: 'numericRange',
    SINGLE_VALUE: 'singleVal'
};
const useSearchUtils = id => {
    const [getFacetsMutation] = useMutation(GET_FACET);

    const getFacets = async url_key => {
        try {
            const { data, error } = await getFacetsAPI({
                getFacetsMutation,
                url_key
            });
            return { data, error };
        } catch (e) {
            return {};
        }
    };

    const initFacetsControllerList = async (engine, facetBuilder, numericFacetBuilder, url_key, listingFacet) => {
        var facetsControllerList = [];
        var controllerConfig = [];
        try {
            var { data, error } = await getFacets(url_key);
            if (url_key) {
                //url key means plp page
                let facetControllerProps = {
                    options: {
                        numberOfValues: document.querySelector("meta[name='categoryLevel']")?.content == 4 ? 25 : 10,
                        field: 'categoryl3'
                    }
                };
                const controllerConf = { key: 'categoryl3', label: 'Subcategory', type: FACET_TYPES.SINGLE_VALUE };
                controllerConfig.push(controllerConf);
                facetsControllerList.push(facetBuilder(engine, facetControllerProps));
            }
            for (let i = 0; i < data?.facetsByCategoryUrlKey?.facets.length; i++) {
                const currFacet = data?.facetsByCategoryUrlKey?.facets[i];
                if (url_key && currFacet?.coveo_attribute === 'categoryl3') {
                    //skip if plppage and subcategoryfacet since already added
                    continue;
                } else {
                    if (data?.facetsByCategoryUrlKey?.facets[i]?.facet_intervals === 'Yes') {
                        let facetControllerProps = {
                            options: {
                                numberOfValues: currFacet?.no_of_intervals || DEFAULT_NUMERIC_FACET_LIMIT,
                                generateAutomaticRanges: true,
                                field: currFacet?.coveo_attribute,
                                rangeAlgorithm: 'equiprobable'
                            }
                        };
                        const controllerConf = {
                            key: currFacet?.coveo_attribute,
                            label: currFacet?.label,
                            type: FACET_TYPES.NUMERIC_RANGE
                        };
                        controllerConfig.push(controllerConf);
                        facetsControllerList.push(numericFacetBuilder(engine, facetControllerProps));
                    } else {
                        let facetControllerProps = {
                            options: {
                                numberOfValues: 10,
                                field: data?.facetsByCategoryUrlKey?.facets[i]?.coveo_attribute
                            }
                        };
                        const controllerConf = {
                            key: currFacet?.coveo_attribute,
                            label: currFacet?.label,
                            type: FACET_TYPES.SINGLE_VALUE
                        };
                        controllerConfig.push(controllerConf);
                        facetsControllerList.push(facetBuilder(engine, facetControllerProps, controllerConf));
                    }
                }
            }
            await listingFacet?.refresh();
            return { facetsControllerList, data, controllerConfig };
        } catch (e) {
            logError('Failed to load facets', false, 'initFacetsControllerList', [
                engine,
                facetBuilder,
                url_key,
                listingFacet
            ]);
            return { facetsControllerList, data: {} };
        }
    };

    return [{ initFacetsControllerList }];
};
export default useSearchUtils;
